import {
  type ICategory,
  type ILanguageType,
  type ITranslation,
} from '@mahawi/eshop-common/dist/src/types';
import { type ILanguageState } from 'customer/react/reducers/language/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { getCategoryUrl } from '../../utils/category';

function LanguageMutationLinks({
  category,
  Language,
}: {
  category: ICategory;
  Language: ILanguageState;
}): React.JSX.Element {
  const { t } = useTranslation();

  const links: React.JSX.Element[] = Language.languages.map(
    ({ code }: ILanguageType): React.JSX.Element => {
      const categoryName: ITranslation | undefined = category.names.find(
        (name: ITranslation): boolean => name.code === code,
      );

      let text: string = `(${code})`;

      if (categoryName) {
        text = `${text} ${categoryName.value}`;
      }

      const categoryTo = getCategoryUrl(category, code);

      return (
        <a key={code} href={categoryTo} hrefLang={code.toLowerCase()}>
          {text}
        </a>
      );
    },
  );

  if (links.length === 0) {
    return <></>;
  }

  return (
    <nav
      className="products container language-mutations"
      aria-label={t('layout.language')}
    >
      <h2>{t('layout.language')}</h2>

      {links}
    </nav>
  );
}

const mapStateToProps = ({ Language, Category }) => ({ Language, Category });

export default connect(mapStateToProps)(LanguageMutationLinks);
